import { EnvironmentProviders } from '@angular/core';
import { provideCoreTrackingProviders } from '@iot-platform/core';
import { TrackingSettingsProviderService } from '../services';
import { trackingSettings } from './tracking.settings';

export const provideI4bTrackingProviders = (): EnvironmentProviders => provideCoreTrackingProviders(trackingSettings, TrackingSettingsProviderService);
export { getEnvironmentProviders } from './data-guard-i4b.provider';
